import { atom } from 'jotai';
import { createJSONStorage } from 'jotai/utils';

// https://github.com/pmndrs/jotai/discussions/1737 and https://github.com/pmndrs/jotai/discussions/1879#discussioncomment-5626120
function atomWithStorage<T>(key: string, initialValue: T) {
  const storage = createJSONStorage<T>(() =>
    typeof window !== 'undefined'
      ? window.localStorage
      : (undefined as unknown as Storage),
  );
  const baseAtom = atom(storage.getItem(key, initialValue));
  return atom(
    get => get(baseAtom),
    (get, set, nextValue: T) => {
      set(baseAtom, nextValue);
      storage.setItem(key, nextValue);
    },
  );
}

export { atomWithStorage };
